(function ($) {

	// Color variants
	let $color_value = $(".product__colors_title--value"),
		current_product_value = $color_value.text()

	// Change color title on hover
	$(".product__colors_color").hover(function () {
		$color_value.text($(this).data('title'))
	}, function () {
		$color_value.text(current_product_value)
	})

	// Show all color variants button
	$(".product__colors_color-button").click(function () {
		$('.product__colors_row').addClass('product__colors_row--show-all');

	})

	//Size chart mouse move
	function mouseMove() {

		const $container = $('#size-chart-drag');

		let startY, startX, scrollLeft, scrollTop, isDown;

		$container.on('mousedown', function (e) {
			isDown = true;
			startY = e.pageY - $container.offset().top;
			startX = e.pageX - $container.offset().left;
			scrollLeft = $container.scrollLeft();
			scrollTop = $container.scrollTop();

			$(document).on('mousemove', mouseMove);
		});

		$container.on('mouseup ', function () {
			isDown = false;
		});

		function mouseMove(e) {
			if (isDown) {
				e.preventDefault();
				// Pohyb vertikálně
				const y = e.pageY - $container.offset().top;
				const walkY = y - startY;
				$container.scrollTop(scrollTop - walkY);

				// Pohyb horizontálně
				const x = e.pageX - $container.offset().left;
				const walkX = x - startX;
				$container.scrollLeft(scrollLeft - walkX);
			}
		}

	}

	$('.product__reviews_show-more').on('click', function () {
		$('div.product__comments').slideDown();
		$(this).hide();
	})

	$(document).gp_ready(function () {
		mouseMove();
	})

})(jQuery);